import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotebookVizResult } from '@mode/notebooks/domain';

@Component({
  selector: 'mode-notebook-cell-result',
  templateUrl: './notebook-cell-result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookCellResultComponent {
  @Input()
  cell!: NotebookVizResult;

  constructor(private window: Window) {}

  downloadCSV(url: string) {
    this.window.open(url, '_blank');
  }
}
